function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
export default function(n) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var str = n.toLocaleString(undefined, _objectSpread({
        style: "currency",
        currency: "usd",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    }, options));
    if ((str.split(".")[1] || "").length === 1) {
        return str + "0";
    } else {
        return str;
    }
};
